/**
 * The relationship choices offered when linking a second parent/guardian —
 * the SAME four the registration form's second-parent block offers
 * (src/forms/utils/seed-default-template.ts), so a parent sees one list
 * everywhere. The backend enum is wider (grandparent, step-parents); those
 * remain valid for existing rows but are not offered here.
 */
import type { ParentRelationship } from '../types';

export const PARENT_RELATIONSHIP_OPTIONS: ReadonlyArray<{
  value: ParentRelationship;
  label: string;
}> = [
  { value: 'MOTHER', label: 'Mother' },
  { value: 'FATHER', label: 'Father' },
  { value: 'GUARDIAN', label: 'Guardian' },
  { value: 'OTHER', label: 'Other' },
];
